<template>
  <pt-live-list-detail class="pt-live-list-detail__page"></pt-live-list-detail>
</template>

<script>
import PtLiveListDetail from 'cps/famous-doctor-hall/pt-live-list/pt-live-list-detail/withData'
export default {
  name: 'pt-live-list-detail__view',
  components: {
    'pt-live-list-detail': PtLiveListDetail
  }
}
</script>
